import { render, staticRenderFns } from "./GroupDescription.vue?vue&type=template&id=0366ddc7&scoped=true"
import script from "./GroupDescription.vue?vue&type=script&lang=js"
export * from "./GroupDescription.vue?vue&type=script&lang=js"
import style0 from "./GroupDescription.vue?vue&type=style&index=0&id=0366ddc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0366ddc7",
  null
  
)

export default component.exports